import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { AppConfig } from "../design/app";
import { IAppConfig } from '../core/models/app-config.model';
import { IApiResponse } from '../core/models/api-response.model';
import { catchError, map, Observable, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SessionExpiredService {
    totalTime = 30;
    INITIAL_END_TIME: any = new Date().getTime() + (this.totalTime * 60 * 1000); 
    endTime: any = this.INITIAL_END_TIME;
    private _appConfig: any;
    constructor(private _datePipe: DatePipe, private _httpClient: HttpClient
    ) {
      this._appConfig = AppConfig;
    }

  getTimeLeft() {
    const val = this.endTime - new Date().getTime();
        return val < 0 ? 0 : val;
    };


    resetTimer() {
        this.endTime = new Date().getTime() + (this.totalTime * 60 * 1000);
    };

    signOutSession() {
        return this._httpClient.get('/api/Account/Signout');
    }
    //To be removed after API creation
 /* 
    signOutSession() : Observable<any>{
        const baseUrl = this._appConfig.session.baseUrl;
        const signoutUrl = this._appConfig.session.signout;
        const apiUrl = `${baseUrl + signoutUrl}`;
        let headers = new HttpHeaders();
        return this._httpClient.get<IApiResponse<any>>(apiUrl, {headers: headers}).pipe(
            map(res => {
                return res.Data;
            }),
            catchError(this.handleError)
        );;
    };

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
        } else {
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        return throwError(
            'Something bad happened; please try again later.');
    };*/

}
